<template>
  <div class="lay-menu" :class="{ 'lay-menu-width': widthState }">
    <div v-if="!widthState" class="lay-menu-list">
      <Menu :theme="theme2" :open-names="['1']" accordion width="200px">
        <MenuItem name="home" to="/home">
          <Icon type="ios-home"/>
          首页
        </MenuItem>
        <template v-for="item in data">
          <MenuItem v-if="!item.children" @click.native.stop="menuClick(item)" :name="item.path">
            <i v-if="item.zdyicon" :class="'iconfont '+item.zdyicon"/>
            <Icon v-else :type="item.icon"/>
            {{ item.meta.title }}
          </MenuItem>
          <Submenu v-if="item.children.length" :name="item.path">
            <template slot="title">
              <i v-if="item.zdyicon" :class="'iconfont '+item.zdyicon"/>
              <Icon v-else :type="item.icon"/>
              {{ item.meta.title }}
            </template>z
            <MenuItem v-for="(iten, num) in item.children" :key="num" @click.native.stop="menuClick(iten)"
                      :name="iten.path">
              {{ iten.meta.title }}
            </MenuItem>
          </Submenu>
        </template>
      </Menu>
    </div>
    <div v-if="widthState" class="lay-menu-icon">
      <Tooltip content="首页" placement="right" :transfer="true">
        <div class="icon-menu" @click.stop="$router.push({
                 path:'/home',
                 query:{
                   lib:$route.query.lib,
                   alis:$route.query.alis
                 }
               })">
          <Icon type="ios-home" size="32"/>
        </div>
      </Tooltip>

      <div class="icon-menu" v-for="(item, index) in data" :key="index">
        <Tooltip v-if="!item.children" :content="item.meta.title" placement="right" :transfer="true">
          <div class="icon-menu" @click.stop="menuClick(item)">
            <i v-if="item.zdyicon" :class="'iconfont '+item.zdyicon" style="font-size: 32px"/>
            <Icon v-else :type="item.icon" size="32"/>
          </div>
        </Tooltip>

        <Poptip popper-class="PopperClass" v-if="item.children" placement="right" width="150" :transfer="true"
                trigger="hover">
          <div class="icon-menu">
            <i v-if="item.zdyicon" :class="'iconfont '+item.zdyicon" style="font-size: 32px"/>
            <Icon v-else :type="item.icon" size="32"/>
          </div>

          <div class="icon-menu-content" slot="content">
            <div v-for="(iten, num) in item.children" :key="num" class="icon-menu-content-list"
                 @click.stop="menuClick(iten)">
              {{ iten.meta.title }}
            </div>
          </div>
        </Poptip>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuState: Boolean
  },

  data() {
    return {
      theme2: 'light',
      //status 4作者 3专家 2编辑 1管理员
      data: [
        {
          path:'adminManage',
          icon:'',
          zdyicon:'icon-guanliyuan',
          status: '1',
          meta: {title: '管理员管理'},
          children: false
        },
        {
          path:'teacherManage',
          icon:'',
          zdyicon:'icon-jiaoshiguanli',
          status: '1',
          meta: {title: '编辑管理'},
          children: false
        },
        {
          path:'experManage',
          icon:'',
          zdyicon:'icon-zhuanjia',
          status: '1',
          meta: {title: '专家管理'},
          children: false
        },
        {
          path:'userManage',
          icon:'',
          zdyicon:'icon-yonghuguanli',
          status: '1',
          meta: {title: '作者管理'},
          children: false
        },
        {
          path:'dataManage',
          icon:'',
          zdyicon:'icon-cailiaoguanli',
          status: '1,4',
          meta: {title: '稿件管理'},
          children: false
        },
        {
          path:'manuscriptType',
          icon:'',
          zdyicon:'icon-gaojian',
          status: '1',
          meta: {title: '稿件类型管理'},
          children: false
        },
        {
          path:'doHandledb',
          icon:'',
          zdyicon:'icon-daibanshixiang',
          status: '2,3',
          meta: {title: '待办稿件'},
          children: false
        },
        {
          path:'doHandlezzb',
          icon:'',
          zdyicon:'icon-banli1',
          status: '2',
          meta: {title: '正在办稿件'},
          children: false
        },
        {
          path:'doHandleyb',
          icon:'',
          zdyicon:'icon-yiban',
          status: '2,3',
          meta: {title: '已办稿件'},
          children: false
        },
      ],
      userData:''
    }
  },

  computed: {
    widthState() {
      return this.menuState
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
  },

  methods: {

    /************************************************************
     *
     * 菜单点击事件
     * @param   {e}                 当前菜单
     *
     ************************************************************/
    menuClick(e) {
      this.$router.push({
                 path:`/${e.path}`,
                 query:{
                   lib:this.$route.query.lib,
                   alis:this.$route.query.alis
                 }
               })
      let data = localStorage.getItem('tabList') ? JSON.parse(this.$crypto.get(localStorage.getItem('tabList'))) : []
      if (data.length) {
        let bool = data.find(el => el.value === e.path)
        if (bool) {
        } else {
          data.push({
            label: e.meta.title,
            value: e.path
          })
          this.handelLocalStorage(data, e.path)
        }
      } else {
        let arr = [
          {
            label: e.meta.title,
            value: e.path
          }
        ]
        this.handelLocalStorage(arr, e.path)
      }
    },

    /************************************************************
     *
     * 更新状态管理
     * @param   {data}              数据
     * @param   {path}              路由
     *
     ************************************************************/
    handelLocalStorage(data, path) {
      localStorage.setItem('tabList', this.$crypto.set(JSON.stringify(data)))
      this.updataStoreTabList()
    },

    /************************************************************
     *
     * 更新状态管理
     *
     ************************************************************/
    updataStoreTabList() {
      this.$store.state.tabList = this.$crypto.get(localStorage.getItem('tabList'))
    }
  },
  watch: {
    userInfo: {
      handler(val, oldValue) {
        this.userData = val?JSON.parse(val):''
        this.data = this.data.filter(item => item.status.indexOf(this.userData.user_type) != -1)
      },
      deep: true
    }
  },
  mounted() {
    this.userData = JSON.parse(this.userInfo)
    this.data = this.data.filter(item => item.status.indexOf(this.userData.user_type) != -1)
  }
}
</script>

<style lang="less">
.lay-menu {
  width: 150px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  transition: all .5s;
  overflow: hidden;

  &-width {
    width: 60px !important;
  }

  &-list {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;

    &::before {
      content: '';
      width: 1px;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: #dcdee2;
    }

    &::-webkit-scrollbar {
      width: 1px;
      background-color: #dcdee2;
    }

    .ivu-menu {
      color: #fff;
      background: rgba(0, 0, 0, 0);
    }
  }

  &-icon {
    width: 60px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;

    .icon-menu {
      width: 60px;
      height: 50px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .icon-menu-content {
      width: 100%;
      max-height: 100%;
    }
  }

}

.icon-menu-content-list {
  padding: 10px 0;
  color: #515a6e;
  cursor: pointer;
  transition: color .2s;
  font-size: 14px;

  &:hover {
    color: #2d8cf0;
  }
}
.ivu-menu-item:hover{
  color: #515a6e!important;
}

.PopperClass {
  max-height: 100%;
  overflow-y: auto;
}
</style>

